import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ComplianceShell from 'features/compliance/ComplianceShell'
import ObligationSetupTable from 'features/compliance/ObligationSetupTable'
import APIService from 'services/APIService'

const api = APIService()

const ObligationSetupPage = ({ bpId: bpIdProp, embedded = false, onTabChange, chromeless = false } = {}) => {
  const routeParams = useParams()
  const bpId = bpIdProp ?? routeParams.bpId
  const [score, setScore] = useState(null)
  const [bpName, setBpName] = useState(null)

  useEffect(() => {
    let cancelled = false
    api.get(`/building-passport/${bpId}/compliance/summary`)
      .then(res => {
        if (cancelled) return
        const data = res?.data?.data
        if (data?.score !== undefined) setScore(data.score)
        if (data?.buildingName) setBpName(data.buildingName)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [bpId])

  return (
    <ComplianceShell activeTab='setup' score={score} bpId={bpId} embedded={embedded} onTabChange={onTabChange} chromeless={chromeless}>
      <ObligationSetupTable bpId={bpId} bpName={bpName} />
    </ComplianceShell>
  )
}

export default ObligationSetupPage
